import { SxProps, Tooltip, tooltipClasses } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import HomeIcon from "assets/icons/HomeIcon";
import { palette } from "theme";

const CurrentCompanyIcon = ({ sx }: { sx?: SxProps }) => (
  <Tooltip
    arrow
    title='Вы находитесь в личном кабинете данной компании'
    componentsProps={{
      popper: {
        sx: {
          [`.${tooltipClasses.tooltip}`]: {
            maxWidth: "none",
          },
        },
      },
    }}>
    <Avatar
      sx={{
        width: 24,
        height: 24,
        backgroundColor: palette.blue[100],
        color: "#fff",
        ...sx,
      }}>
      <HomeIcon sx={{ width: 16, height: 16 }} />
    </Avatar>
  </Tooltip>
);

export default CurrentCompanyIcon;
